import { css } from 'styled-components';
import { getComponents } from '../theme/components.js';

const {
  defaultTextStyles
} = getComponents({});
const textStyle = type => ({
  theme
}) => {
  const styles = theme.components.defaultTextStyles[type];
  return css(["font-family:", ",Arial,Helvetica,sans-serif;font-size:", ";letter-spacing:", ";line-height:", ";font-weight:", ";", ";"], styles.fontFamily, styles.fontSize, styles.letterSpacing, styles.lineHeight, styles.fontWeight, 'textDecoration' in styles && `text-decoration: ${styles.textDecoration}`);
};
const isTextStyle = value => {
  return Object.keys(defaultTextStyles).includes(value);
};

export { defaultTextStyles, isTextStyle, textStyle };
//# sourceMappingURL=textStyle.js.map
